import { render } from "./DexTabMenu.vue?vue&type=template&id=eb4a7bd2"
import script from "./DexTabMenu.vue?vue&type=script&lang=js"
export * from "./DexTabMenu.vue?vue&type=script&lang=js"

import "./DexTabMenu.vue?vue&type=style&index=0&id=eb4a7bd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__